import { AuthProvider } from './auth';
import { ToastProvider } from './toast';
import { ProdutoHookProvider } from './produtohook';
import { AcessoHookProvider } from './acessohook';
import { CartProvider } from './cart';

type AppProviderProps = {
	children: React.ReactNode;
}

const AppProvider: React.FC<AppProviderProps> = ({ children }) => (
  <AuthProvider>
		<ToastProvider>
			<ProdutoHookProvider>
				<CartProvider>
					<AcessoHookProvider>
							{children}
					</AcessoHookProvider>
				</CartProvider>
			</ProdutoHookProvider>
		</ToastProvider>
  </AuthProvider>
);

export default AppProvider;
